import React from "react";
import { trackAmplitudeEvent } from "@/utils/amplitude";

interface InstallModalProps {
  onClose: () => void;
  onInstall: () => void;
}

const InstallModal: React.FC<InstallModalProps> = ({ onClose, onInstall }) => {
  const handleInstall = () => {
    trackAmplitudeEvent("PWA_INSTALL_CLICKED");
    onInstall();
  };

  const handleSkip = () => {
    trackAmplitudeEvent("PWA_INSTALL_SKIPPED");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="mx-auto max-w-sm rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-2 text-lg font-semibold">Install P2P.me</h2>
        <p className="mb-8">You can install P2P.me for a better experience.</p>
        <div className="flex justify-between">
          <button
            onClick={handleInstall}
            className="hover:bg-primary-dark rounded bg-primary px-4 py-2 text-black">
            Install
          </button>
          <button
            onClick={handleSkip}
            className="rounded border border-gray-300 px-4 py-2 hover:bg-gray-100">
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallModal;
